import { Injectable, OnInit, SecurityContext } from '@angular/core';
import { MarketSegmentType } from './../../../shared/enums/market-segment-type';
import { UrlConfig } from './../../config/url.config';
import { RootObject } from './../../model/root.model';
import { Broker } from './../../model/broker.model';
import { Router } from '@angular/router';
import { NewHireDBModel } from '../../model/new-hireDB.model';
import { ValidationMessage } from './../../../shared/constants/constant';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { OAuthService, JwksValidationHandler } from 'angular-oauth2-oidc';
import { AuthorizationService } from './../auth/auth.service';
import { ApplicationInsightsService } from './../application-insights/application-insights.service';
import { environment } from './../../../../environments/environment';
import { authConfig } from './../../config/auth.config';
import { AlertPopupComponent } from './../../../shared/components/alert-popup/alert-popup.component';
import {
  DefineContributionRequest,
  PlanRatingRequest,
  ContributionMember,
} from './../../model/define-contribution-request';
import { EmployerContributionType } from './../../../shared/enums/employee-contribution-type.enum';
import { Email } from '../../model/delivery.model';
import { OosPlanListComponent } from './../../../plan-selection/oos-plan-list/oos-plan-list.component';
import { Carrier } from './../../model/carrier.model';
import { Subject, Subscription } from 'rxjs';
import { SupportedLanguage } from '../../model/supportedLanguage';
import { NewHireService } from '../new-hire/new-hire.service';
import { filter } from 'rxjs/operators';
import { NewHire } from '../../model/new-hire.model';
import { DomSanitizer } from '@angular/platform-browser';
@Injectable({
  providedIn: 'root',
})
export class CommonService implements OnInit {
  groupId =
    localStorage.getItem('group_id') == null ||
      localStorage.getItem('group_id') == undefined
      ? 0
      : parseInt(localStorage.getItem('group_id') || '0');

  existingGroupId =
    localStorage.getItem('group_id') == null ||
      localStorage.getItem('group_id') == undefined
      ? -1
      : parseInt(localStorage.getItem('group_id'));

  existingfinalQuoteId =
    localStorage.getItem('final_quote_id') == null ||
      localStorage.getItem('final_quote_id') == undefined
      ? 0
      : parseInt(localStorage.getItem('final_quote_id') || '0');
  existingIsAnyFinalQuote =
    localStorage.getItem('isAny_Final_Quote') == null ||
      localStorage.getItem('isAny_Final_Quote') == undefined
      ? 'false'
      : localStorage.getItem('isAny_Final_Quote') || 'false';
  stateId =
    localStorage.getItem('broker_state') == null ||
      localStorage.getItem('broker_state') == undefined
      ? 0
      : parseInt(localStorage.getItem('broker_state') || '0');
  brokerId: number = Number(localStorage.getItem('broker_id'));

  loggedInUserName: string;

  public isTermsAccepted = false;
  public isFromBrokerMobileApp = false;

  // Group Details Page
  finalQuoteSelections: any = {};
  finalQuoteId: number = 0;
  isAnyFinalQuote: boolean = false;
  isFinalQuoteChecked: boolean = false;
  invalidSicCode: boolean = false;
  invalidZipCode: boolean = false;
  invalidZipCodeState: boolean = false;
  groupDetailsData: RootObject = new RootObject();
  originalNewHire: any = [];
  selectedEmployee: any;
  existingGroupDetails: any;
  selectedSicCodeId: number; // needed to saved to Group Table in GACensus
  selectedAgency: any;
  MarketSegmentTypeId: number = MarketSegmentType.Group;
  selectedGroupBrokerDetail: Broker = new Broker();
  brokerInfo: Broker = new Broker();
  newHireData: NewHireDBModel = new NewHireDBModel();
  groupStateId: any = 54; // default California
  enrollmentDates: any = [];
  enrollmentDatesSubject = new Subject<string>();

  nhws_id: number = localStorage.getItem('nhws_id')
    ? parseInt(localStorage.getItem('nhws_id'))
    : 0;
  isCompleted: boolean =
    localStorage.getItem('isCompleted') == 'true' ? true : false;
  onEditModeDataChanged: boolean = false;
  OnEditGroupInformationChangedForPlanSelection: boolean = false;
  OnEditGroupInformationChangedForContribution: boolean = false;
  editModeGroupInformationOriginalData: any;
  editModeEmployeeDetailsOriginalData: any;

  editModeDependentsDetailsOriginalData: any;
  dependentsDetailsFormGroupValue: any;
  editModeSpouseDetailsOriginalData: any;
  spouseDetailsFormGroupValue: any;

  // Plan Selection Page
  primaryCarriers: any = [];

  currentSelectedCarrier: any;
  isPlanBasedAutoPackageSelected: any = false;

  displayPackagesByCarrier: any = [];
  displayPlansByCarrier: any = [];
  displayPlansByCarrierOriginal: any = [];
  carriersLogos: any;

  selectedPrimaryCarrierId: any = 0;
  selectedWrap1CarrierId: any = 0;
  selectedWrap2CarrierId: any = 0;

  selectedPrimaryCarrierName: any;
  selectedWrap1CarrierName: any;
  selectedWrap2CarrierName: any;

  availablePrimaryPackages: any = [];
  availableWrap1Packages: any = [];
  availableWrap2Packages: any = [];

  selectedPrimaryPackageId: any = 0;
  selectedWrap1PackageId: any = 0;
  selectedWrap2PackageId: any = 0;

  selectedPrimaryPlans: any = [];
  selectedWrap1Plans: any = [];
  selectedWrap2Plans: any = [];

  allPrimaryPlansOnPackageId: any = [];
  allWrap1PlansOnPackageId: any = [];
  allWrap2PlansOnPackageId: any = [];

  liteWrapCarriers: any = [];

  newHire = new RootObject();
  medicalInfo: any = {};
  deliveryOptions: any;

  public selectedOOSEmpPlansIndexesMap = new Map<any, any>();

  oosEmployeesPlans: any = new Map<any, any>();
  showWrap1: boolean = false;
  showWrap2: boolean = false;
  public oosDialogRef: MatDialogRef<OosPlanListComponent>;

  // Wrap Carriers

  wrappedCarriers: any;
  firstWrapCarrierRatingRuleIds: any = [];
  secondWrapCarrierRatingRuleIds: any = [];
  carrierRatingRuleIds: any = [];

  // Contribution Page
  localNewHireData: RootObject;
  carrierData: any;
  errorMessage: string = '';
  showValidationErrorIfAny: boolean = false;
  showValidationErrorOn = 'Top';
  showDefineContribution = false;
  showOOSContribution = false;
  bundle: DefineContributionRequest;
  employerContributionType: any = EmployerContributionType;
  planRatingRequest: PlanRatingRequest;
  members: ContributionMember[];
  premiumsObject: any;
  activeContribution = {
    isNone: true,
    isPercentage: false,
    isDollar: false,
  };

  // Delivery Page
  public emails: Email[] = [];

  supportedLanguages: SupportedLanguage[];
  employeesForRates: NewHire[] = [];

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private oauthService: OAuthService,
    private _authorizationService: AuthorizationService,
    private idle: Idle,
    private _newHireService: NewHireService,
    private _applicationInsightsService: ApplicationInsightsService,
    private sanitization: DomSanitizer
  ) {
    this._applicationInsightsService.turnOn();
    this.ClientAuthenticationWithSecureAccess();
    this.ConfigureUserIdleState();
  }

  ngOnInit() { }
  clearLocalStorageNhwsId() {
    localStorage.removeItem('nhws_id');
    localStorage.removeItem('isCompleted');
    localStorage.removeItem('group_id');
    localStorage.removeItem('final_quote_id');
    localStorage.removeItem('isAny_Final_Quote');
    this.nhws_id = 0;
    this.isCompleted = false;
    this.onEditModeDataChanged = false;
    this.OnEditGroupInformationChangedForPlanSelection = false;
    this.OnEditGroupInformationChangedForContribution = false;
    this.editModeGroupInformationOriginalData = null;
  }
  resetGroupDetailsScreenFields() {
    this.finalQuoteSelections = {};
    this.finalQuoteId = 0;
    this.isAnyFinalQuote = false;
    this.isFinalQuoteChecked = false;
    this.invalidSicCode = false;
    this.invalidZipCode = false;
    this.invalidZipCodeState = false;
    this.groupDetailsData = new RootObject();
    this.originalNewHire = [];
    this.selectedEmployee = null;
    this.existingGroupDetails = null;
    this.selectedSicCodeId = 0;
    this.newHireData = new NewHireDBModel();
  }

  resetPlanScreenFields() {
    this.primaryCarriers = [];
    this.currentSelectedCarrier = null;
    this.displayPackagesByCarrier = [];
    this.displayPlansByCarrier = [];
    this.displayPlansByCarrierOriginal = [];

    this.isPlanBasedAutoPackageSelected = false;

    this.selectedPrimaryCarrierId = 0;
    this.selectedWrap1CarrierId = 0;
    this.selectedWrap2CarrierId = 0;

    this.selectedPrimaryCarrierName = '';
    this.selectedWrap1CarrierName = '';
    this.selectedWrap2CarrierName = '';

    this.availablePrimaryPackages = [];
    this.availableWrap1Packages = [];
    this.availableWrap2Packages = [];

    this.selectedPrimaryPackageId = 0;
    this.selectedWrap1PackageId = 0;
    this.selectedWrap2PackageId = 0;

    this.selectedPrimaryPlans = [];
    this.selectedWrap1Plans = [];
    this.selectedWrap2Plans = [];

    this.allPrimaryPlansOnPackageId = [];
    this.allWrap1PlansOnPackageId = [];
    this.allWrap2PlansOnPackageId = [];
    this.liteWrapCarriers = [];
    this.newHire = new RootObject();
    this.medicalInfo = {};
    this.carrierData = new Carrier();

    this.selectedOOSEmpPlansIndexesMap = new Map<any, any>();

    this.oosEmployeesPlans = new Map<any, any>();
    this.showWrap1 = false;
    this.showWrap2 = false;

    // Wrap Carriers
    this.wrappedCarriers = null;
    this.firstWrapCarrierRatingRuleIds = [];
    this.secondWrapCarrierRatingRuleIds = [];
    this.carrierRatingRuleIds = [];
  }

  resetContributionScreenFields() {
    this.newHireData = new NewHireDBModel();
    this.carrierData = new Carrier();
    this.localNewHireData = new RootObject();

    this.errorMessage = '';
    this.showValidationErrorOn = 'Top';
    this.showDefineContribution = false;
    this.showOOSContribution = false;
    this.bundle = new DefineContributionRequest();
    this.employerContributionType = EmployerContributionType;
    this.planRatingRequest = new PlanRatingRequest();
    this.members = [];
    this.premiumsObject = null;
    this.activeContribution = {
      isNone: true,
      isPercentage: false,
      isDollar: false,
    };
  }

  getRedirectUrl(): string {
    var redirectUrl = UrlConfig.quoteLiteUrl;
    if (localStorage) {
      var storedRedirectUrl = localStorage.getItem('redirectUrl');
      var tempFromQuoteLiteItem = localStorage.getItem('isFromQuotelite');
      var tempFromWbQuote = localStorage.getItem('DirectFromWBQuote');
      var IsFromWBQuote = localStorage.getItem('IsFromWBQuote');
      this.clearLocalStorageItems();
      if (
        storedRedirectUrl != null &&
        storedRedirectUrl != undefined &&
        storedRedirectUrl != ''
      ) {
        redirectUrl = storedRedirectUrl;
      } else if (
        tempFromQuoteLiteItem !== null &&
        tempFromQuoteLiteItem !== undefined &&
        tempFromQuoteLiteItem == 'True'
      ) {
        redirectUrl = UrlConfig.quoteLiteUrl;
      } else if (
        tempFromWbQuote !== null &&
        tempFromWbQuote !== undefined &&
        tempFromWbQuote == 'True'
      ) {
        redirectUrl = UrlConfig.wbQuoteUrl;
      } else if (
        IsFromWBQuote !== null &&
        IsFromWBQuote !== undefined &&
        IsFromWBQuote == 'Yes'
      ) {
        redirectUrl = UrlConfig.wbQuoteUrl;
      }
    }
    return redirectUrl;
  }

  redirect() {
    window.open(this.getRedirectUrl(), '_self');
  }

  clearLocalStorageItems() {
    localStorage.removeItem('broker_LicenseNumber');
    localStorage.removeItem('broker_Phone');
    localStorage.removeItem('broker_id');
    localStorage.removeItem('broker_name');
    localStorage.removeItem('broker_state');
    localStorage.removeItem('group_id');
    localStorage.removeItem('final_quote_id');
    localStorage.removeItem('isAny_Final_Quote');
    localStorage.removeItem('IsFromWBQuote');
    localStorage.removeItem('salesRepName');
    localStorage.removeItem('salesRepEmail');
    localStorage.removeItem('IsDirectUser');
    localStorage.removeItem('isFromQuotelite');
    localStorage.removeItem('DirectFromWBQuote');
    window.localStorage.clear();
  }

  setBrokerMobileConfig() {
    this.isFromBrokerMobileApp =
      Number(this.getValueFromLocalStorage('isBma')) === 1;
  }

  getValueFromLocalStorage(localStorageName: string) {
    let value: string = localStorage.getItem(localStorageName);
    if (value == undefined || value == null) {
      return '';
    }
    return value;
  }

  getCurrentGroupId() {
    var censusGroupId = 0;
    if (localStorage) {
      var groupId = localStorage.getItem('group_id');
      if (groupId != null && groupId != undefined && groupId != '') {
        censusGroupId = Number(groupId);
      }
    }
    return censusGroupId;
  }

  // Disclaimer Handling
  redirectToDisclaimer() {
    let showPopup = true;

    // don't show disclaimer, if redirected from WBQuote, QuoteLite, or Broker mobile apps
    if (showPopup) {
      let fromApp = localStorage.getItem('FromApp');
      if (fromApp == 'wbquote' || fromApp == 'quotelite' || fromApp == 'bma') {
        showPopup = false;
      }
    }

    // don't show disclaimer, if the user has already agreed to the disclaimer (shown on this website).
    if (showPopup) {
      let wasAccepted =
        localStorage.getItem('isWebApp') == 'true' || this.isTermsAccepted;
      if (wasAccepted) {
        showPopup = false;
      }
    }

    // show the popup disclaimer if needed
    if (showPopup) {
      this.router.navigateByUrl('/disclaimer');
    } else {
      let self = this;
      setTimeout(function () {
        self.cleanWBQuoteandReDirectUrlForNextSession();
      }, 5000);
    }
  }

  cleanWBQuoteandReDirectUrlForNextSession() {
    if (
      localStorage.getItem('IsDirectUser') == 'Yes' &&
      localStorage.getItem('IsFromWBQuote') == 'Yes'
    ) {
      //double redirection for wbquote
      localStorage.removeItem('IsFromWBQuote');
      localStorage.setItem('DirectFromWBQuote', 'True');
    }
    if (localStorage.getItem('redirectUrl') == UrlConfig.quoteLiteUrl) {
      localStorage.removeItem('redirectUrl');
      localStorage.setItem('isFromQuotelite', 'True');
    }
  }

  private ClientAuthenticationWithSecureAccess() {
    this.oauthService.configure(authConfig);
    this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    this.oauthService.setStorage(localStorage);

    this.oauthService.loadDiscoveryDocument().then((doc) => {
      this.oauthService
        .tryLogin()
        .catch((err) => {
          console.error(err);
        })
        .then(() => {
          if (
            !this.oauthService.hasValidIdToken() ||
            !this.oauthService.hasValidAccessToken()
          ) {
            this.oauthService.initImplicitFlow();
          } else {
            const userEmail = this._authorizationService.email;
            const userName = this._authorizationService.FullName;
            const userRole = this._authorizationService.userRole;
            this._applicationInsightsService.setUserId(
              userEmail,
              userName,
              userRole
            );
          }
        });
    });

    this.oauthService.setupAutomaticSilentRefresh();

    let oauthSubscription = this.oauthService.events.subscribe((e) => {
      console.log('oauth/oidc event', e);

      if (e.type === 'token_received') {
        console.log(this.oauthService.getAccessToken());
        const userEmail = this._authorizationService.email;
        const userName = this._authorizationService.FullName;
        const userRole = this._authorizationService.userRole;
        this._applicationInsightsService.setUserId(
          userEmail,
          userName,
          userRole
        );
      }
    });

    this.oauthService.events
      .pipe(
        filter((e) => ['session_terminated', 'session_error'].includes(e.type))
      )
      .subscribe((e) => {
        console.log('Your session has been terminated!');
        sessionStorage.clear();
        window.location.href = environment.SingleSignoutRedirect;
      });
  }
  displayAlertPopUp() {
    this.dialog.open(AlertPopupComponent, {
      // width: '250px',
      autoFocus: false,
      data: {
        title: 'Session Idle',
        Message: ValidationMessage.IdleSession,
        showCancelButton: true,
      },
    });
  }

  private ConfigureUserIdleState() {
    this.idle.setIdle(environment.idleTime);

    this.idle.setTimeout(environment.idleTimeout);

    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleStart.subscribe(() => {
      this.displayAlertPopUp();
    });

    this.idle.onIdleEnd.subscribe(() => {
      console.log('IdleEnd');
    });

    this.idle.onTimeoutWarning.subscribe((countdown: number) => {
      console.log('TimeoutWarning: ' + countdown);
    });

    this.idle.onTimeout.subscribe(() => {
      console.log('Timeout');
      this.clearLocalStorageItems();
      this.redirect();
    });

    // start watching for idleness right away.
    this.idle.watch();
  }

  // load supported languages once and ahead of time.
  loadSupportedLanguages(): void {
    // initialize with English, then wait for ajax to fetch the complete list.
    // purpose: if ajax fails (for whatever reasons), we have one language to proceed with.
    this.supportedLanguages = [{ Id: 0, Name: 'English' }];

    this._newHireService
      .getSupportedLanguages()
      .subscribe((resp: SupportedLanguage[]) => {
        if (resp) {
          this.supportedLanguages = resp;
        }
      });
  }
  public removeSpecialChar(inputData: string): string {
    return inputData.replace(/[^a-zA-Z 0-9]+/g, '');
  }

  public htmlSanitization(inputData: string): string {
    return this.sanitization
      .sanitize(SecurityContext.HTML, inputData)
      .replace(/<\/?[^>]+>/g, '');
  }

  public onKeyDown(event: any) {
    var key = window.event ? event.keyCode : event.which;
    if (key == 188 || key == 190) {
      event.preventDefault();
    }
  }

  public isInputValid(inputData: string): boolean {
    if (inputData && (inputData.includes('<') || inputData.includes('>'))) {
      return false;
    }
    return true;
  }

  setEditModeByNewHireId(newHireId: number) {
    if (newHireId) {
      localStorage.setItem(`editMode_${newHireId}`, this.onEditModeDataChanged.toString());
    }
  }

  removeEditModeByNewHireId(newHireId: number) {
    if (newHireId && localStorage.getItem(`editMode_${newHireId}`)) {
      localStorage.removeItem(`editMode_${newHireId}`);
    }
  }

  getEditModeByNewHireId(newHireId: number) {
    if (newHireId && localStorage.getItem(`editMode_${newHireId}`)) {
      return localStorage.getItem(`editMode_${newHireId}`);
    }
    return '';
  }

  onLoadSetEditMode(newHireId: number) {
    if (this.getEditModeByNewHireId(newHireId)) {
      this.onEditModeDataChanged = true;
      this.setEditModeByNewHireId(newHireId);
    }
  }
}
